<template>
  <div id="mainNav">
    <v-navigation-drawer v-model="drawer" :stateless="dialog" fixed temporary style="width: 80%; z-index: 2001;">
      <v-btn class="close" v-on:click="emitCloseDrawer">
        <i class="fas fa-close font-md white-text"></i>
      </v-btn>
      <div v-if="member.user" class="gradient-blue member-details white-text p-15 center">
        <span class="profile-img m-b-10 center"></span>
        <h1 class="font-lg bold m-b-5">{{ member.full_name | capitalize }}</h1>
        <p class="font-xs">{{ member.user.email }}</p>
        <p class="font-xs">Verified affiliate since {{ member.joined_at | moment }}</p>
      </div>
      <div v-if="member">
        <v-row class="center p-lr-15">
          <v-col cols="6" class="balance-border">
            <span class="gray-d-text font-xs">Withdrawable Balance</span>
            <h4 class="font-md m-t-3">{{ member.available_balance }} {{ currency }}</h4>
          </v-col>
          <v-col cols="6">
            <span class="gray-d-text font-xs">Running Revenue Share</span>
            <h4 class="font-md m-t-3">{{ member.preferences.runningRevenueShare }} {{ currency }}</h4>
          </v-col>
        </v-row>
        <div class="divider bg-gray"></div>
      </div>
      <div class="p-t-15 mobile-menu">
        <p class="p-b-10 semibold"><v-btn :to="{ name: 'dashboard' }"><i class="fas fa-columns gray-l-text m-r-5"></i> Dashboard</v-btn></p>
        <p class="p-b-10 semibold"><v-btn :to="{ name: 'withdrawal' }"><i class="fas fa-coins gray-l-text m-r-5"></i> Withdrawal</v-btn></p>
        <p class="p-b-10 semibold"><v-btn :to="{ name: 'transaction-history' }"><i class="fas fa-history gray-l-text m-r-5"></i> Transaction History</v-btn></p>
        <p class="p-b-10 semibold"><v-btn :to="{ name: 'statement-of-account' }"><i class="fas fa-receipt gray-l-text m-r-5"></i> Statement of Account</v-btn></p>
        <p class="p-b-10 semibold"><v-btn :to="{ name: 'affiliate-tools' }"><i class="fas fa-users gray-l-text m-r-5"></i> Affiliate Tools</v-btn></p>
        <p class="p-b-10 semibold"><v-btn :to="{ name: 'kyc' }"><i class="fas fa-user-check gray-l-text m-r-5"></i> KYC</v-btn></p>         
      </div>
      <div class="sidenav-footer p-t-15 p-lr-15 w-100">
        <p class="p-b-10 semibold"><v-btn :to="{ name: 'settings' }" style="margin-left: -17px;"><i class="fas fa-cog gray-l-text m-r-5"></i> Settings</v-btn></p>
        <p class="p-b-10 semibold" @click="logout()"><i class="fas fa-sign-out-alt gray-l-text m-r-5"></i> Log Out</p>
      </div>
    </v-navigation-drawer>

    <div class="desktop-view desktop-sidenav">
      <template>
        <v-card>
          <v-navigation-drawer
                  expand-on-hover
                  permanent
          >
            <v-list
                    nav
                    dense
            >
              <v-list-item link :to="{ name: 'dashboard' }">
                <v-list-item-icon>
                  <i class="fas fa-columns font-xl white-text"></i>
                </v-list-item-icon>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item>
              <v-list-item link :to="{ name: 'withdrawal' }">
                <v-list-item-icon>
                  <i class="fas fa-coins font-xl white-text"></i>
                </v-list-item-icon>
                <v-list-item-title>Withdrawal</v-list-item-title>
              </v-list-item>
              <v-list-item link :to="{ name: 'transaction-history' }">
                <v-list-item-icon>
                  <i class="fas fa-history font-xl white-text"></i>
                </v-list-item-icon>
                <v-list-item-title>Transaction History</v-list-item-title>
              </v-list-item>
              <v-list-item link :to="{ name: 'statement-of-account' }">
                <v-list-item-icon>
                  <i class="fas fa-receipt font-xl white-text"></i>
                </v-list-item-icon>
                <v-list-item-title>Statement of Account</v-list-item-title>
              </v-list-item>
              <v-list-item link :to="{ name: 'affiliate-tools' }">
                <v-list-item-icon>
                  <i class="fas fa-users font-xl white-text"></i>
                </v-list-item-icon>
                <v-list-item-title>Affiliate Tools</v-list-item-title>
              </v-list-item>
              <v-list-item link :to="{ name: 'kyc' }">
                <v-list-item-icon>
                  <i class="fas fa-user-check font-xl white-text"></i>
                </v-list-item-icon>
                <v-list-item-title>KYC</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </v-card>
      </template>
    </div>

    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <i class="fas fa-chevron-up"></i>
    </v-btn>
  </div>
</template>

<script>
import customFilters from '../../utility/custom-filters'

export default {
  name: 'NavDrawer',
  data() {
    return {
      drawer: false,
      dialog: true,
      member: '',
      currency: 'EUR',
      fab: false,
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'auth-login' })
      })
    },
    setOpen (state) {
      this.drawer = state
    },
    emitCloseDrawer () {
      this.$emit('closeDrawer', false)
    },
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    }
  },
  watch: {
    open(value) {
      this.setOpen(value)
    }
  },
  props: {
    open: Boolean
  },
  filters: {
    moment(date) {
      return customFilters.moment(date, 'MMMM D, YYYY')
    },
    capitalize(value) {
      return customFilters.capitalize(value)
    }
  },
  mounted() {
    setTimeout(() => {
      this.member = JSON.parse(localStorage.getItem('member'))
    }, 1000)
   
  }
}
</script>

<style scoped>
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: auto;
    min-width: auto;
    padding: 2px 15px;
    text-transform: unset;
    font-weight: 600 !important;
  }
  .black-text { color: #000; }
  .close {
    margin: 3px -10px 0px 0;
    position: absolute;
    right: 5px;
    top: 5px;
  }
  .v-list-item__title {
    color: #fff;
    font-size: 14px !important;
  }
  .v-btn--active i {
    color: #FBCC04;
  }
  .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
    opacity: 0;
  }
  @media only screen and (max-height: 440px) {
    .profile-img {
      width: 65px;
      height: 65px;
      margin-bottom: 0;
      position: absolute;
      left: 16px;
      top: 12px;   
    }
    .close{
      z-index: 99;
    }
    .member-details{
      padding: 15px;
      text-align: left;
      padding-left: 96px;
      position: relative;
    }
    .mobile-menu {
      padding-top: 3px !important;
    }    
    .mobile-menu p {
      padding: 1px 0 !important;
    }    
    .mobile-menu p a {
      font-size: 12px !important;
    }    
    .sidenav-footer {
      position: relative;
      bottom: 0;
      border-top: 1px solid #DEDEDE;
    }    
    .sidenav-footer p a {
      font-size: 11px !important;
    }   
    .sidenav-footer p {
      font-size: 11px !important;
      padding-bottom: 4px !important;
    }
    .desktop-view .v-list-item__icon{
      margin-top: 5px !important;
      margin-bottom: 5px !important;
    }   
    .desktop-view .v-list-item{
      min-height: 30px;
    }             
  }  
</style>